import * as API from 'common/constant/routes'
import { getJson, postJson } from 'helper/http'
import toSnakeCase from '@deliverance-ai/map-keys-case/to-snake-case'

export const getCategories = (management) => getJson(API.GET_CATEGORIES, {}, { management })
export const addCategory = (newCategory) => postJson(API.ADD_CATEGORY, {}, { ...newCategory })
export const editCategory = (category, parent) => postJson(API.EDIT_CATEGORY, {}, { ...category, parent })
export const deleteCategory = (uuid) => postJson(API.DELETE_CATEGORY, {}, { uuid })
export const addSubCategory = (newSubCategory) => postJson(API.ADD_SUB_CATEGORY, {}, { ...newSubCategory })
export const editSubCategory = (subCategory) => postJson(API.EDIT_SUB_CATEGORY, {}, { ...subCategory })
export const deleteSubCategory = (uuid) => postJson(API.DELETE_SUB_CATEGORY, {}, { uuid })
export const searchCategories = (searchTerm) => getJson(API.SEARCH_CATEGORIES, {}, toSnakeCase({ searchTerm }))
export const saveCategoriesOrder = (categories) => postJson(API.SAVE_CATEGORIES_ORDER, {}, { categories })
